// extracted by mini-css-extract-plugin
export var closeButton = "_1c-1";
export var container = "_1c-0";
export var fullModalImage = "_1c-2";